export default "__VITE_ASSET__dfb414a3__"